import { render, staticRenderFns } from "./order-delivery-by-self.vue?vue&type=template&id=65aa072d&scoped=true&lang=pug&"
import script from "./order-delivery-by-self.vue?vue&type=script&lang=js&"
export * from "./order-delivery-by-self.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa072d",
  null
  
)

export default component.exports